import fetch from '@/utils/fetch'

export function page (data) {
  data.languages = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  return fetch({
    url: '/api/query/page/order-pc',
    method: 'post',
    data
  })
}

export function getDetail (data) {
  data.languages = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  return fetch({
    url: '/api/query/info',
    method: 'post',
    data
  })
}

export function getTicketDetail (data) {
  data.languages = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  return fetch({
    url: '/api/query/list',
    method: 'post',
    data
  })
}

// 检票记录
export function getCheckLogList (data) {
  data.languages = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  return fetch({
    url: '/trip/order/ticket/check/log/list',
    method: 'POST',
    data
  })
}

export function getTicketInfo (data) {
  data.languages = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  return fetch({
    url: '/api/integration/get-ticket-for-refund',
    method: 'POST',
    data
  })
}

export function ticketRefund (data) {
  return fetch({
    url: '/api/integration/refund',
    method: 'POST',
    data
  })
}

export function ticketReplenishRefund (data) {
  return fetch({
    url: '/api/integration/refund-batch',
    method: 'POST',
    data
  })
}

// 支付查询
export function PayForTheQuery (orderNo) {
  return fetch({
    url: `/pay/jsapi/check-unpaid/${orderNo}`,
    method: 'post'
  })
}

// 查询可改签票信息
export function findRebook (data) {
  data.languages = localStorage.getItem('languageCode') || 'Simplified_Chinese'
  return fetch({
    url: '/api/integration/pc-find-for-rebook',
    method: 'post',
    data
  })
}

// 改签票接口
export function canReBook (data) {
  return fetch({
    url: '/api/integration/pc-rebook',
    method: 'post',
    data
  })
}

export function isCanRebook () {
  return fetch({
    url: '/bms/sys-config/info-by-code/IS_CAN_REBOOK',
    method: 'post'
  })
}

export function getReplenishList (data) {
  return fetch({
    url: '/api/query/replenish-info-by-api-wechat',
    method: 'post',
    data
  })
}

export function saveReplenishOrder (data) {
  return fetch({
    url: '/api/integration/save-pc-replenish-order',
    method: 'post',
    data
  })
}

export function handleChildrenInfo (data) {
  return fetch({
    url: '/api/query/children-ticket-info',
    method: 'POST',
    data
  })
}
